export const STARMANIA_AUTH_TOKEN_STORAGE_KEY = 'starmania/auth';
export const SUPERBUS_AUTH_TOKEN_STORAGE_KEY = 'superbus/auth';
export const STARMANIA_USER_STORAGE_KEY = 'starmania/user';
export const SUPERBUS_USER_STORAGE_KEY = 'superbus/user';

export const STARMANIA_ACTIVE_ARTIST_STORAGE_KEY = 'starmania/active_artist';

export const LEGACY_SELECTED_ARTIST_KEY = 'selectedArtist';

export const storageDefaultKey = 'deezer';
export const storageUserTokenKey = 'UserToken';

export const storageImpersonateKey = 'impersonate';

export enum StorageKeys {
	START_DATE = 'startDate',
	END_DATE = 'endDate',
	OFFER = 'offer',
	COUNTRY = 'country',
}
